import { observer } from 'mobx-react-lite'

import { PricesConfig, PriceTypesMatching, PriceTypesMatchingBaseProps } from '../PriceTypesMatching'

import { YandexMarketAccountModel } from '../../../server/mpsklad_core/Models/YandexMarketAccountModel'
import { YandexMarketPriceTypesModel } from '../../../server/mpsklad_core/Models/YandexMarketPriceTypesModel'

export const YandexMarketPriceTypesMatching =
  observer(
    ({account, onChange}: PriceTypesMatchingBaseProps<YandexMarketAccountModel, YandexMarketPriceTypesModel>) =>
      <PriceTypesMatching<YandexMarketAccountModel, YandexMarketPriceTypesModel>
        account={account}
        pricesConfig={pricesConfig}
        initialPriceIds={{
          msBasePriceId: account.msBasePriceId,
          msMinimalPriceId: account.msMinimalPriceId,
          msPriceId: account.msPriceId
        }}
        tooltips={{
          msMinimalPriceId: 'Используется для акций Yandex.Market, например, «Бестселлеры». Отправляется только при включённых общих ценах.'
        }}
        onChange={onChange}
        onUpdateAccount={updatedPrices => {
          account.msMinimalPriceId = updatedPrices.msMinimalPriceId
        }}
      />)

const pricesConfig = {
  msBasePriceId: 'Цена Yandex.Market без скидки',
  msMinimalPriceId: 'Цена Yandex.Market минимальная',
  msPriceId: 'Цена Yandex.Market'
} as const satisfies PricesConfig<YandexMarketPriceTypesModel>